export default "__VITE_ASSET__BmW8zbit__"